import React, { useState } from "react";

import Modal from "../../../components/Modal";
import { useNotification } from "../../../contexts/NotificationContext";
import { PricingCollection, deleteItem } from "../../pricing/repository";

interface Pending {
  id: string;
  label: string;
}

/** Exclusão com confirmação (mesmo Modal usado nas reservas). */
export function useDeleteItem(collection: PricingCollection, noun: string) {
  const [pending, setPending] = useState<Pending | null>(null);
  const { showNotification } = useNotification();

  const confirm = async () => {
    if (!pending) return;
    try {
      await deleteItem(collection, pending.id);
      showNotification("success", `${noun} "${pending.label}" removido(a).`);
    } catch {
      showNotification("error", `Erro ao remover ${noun.toLowerCase()}.`);
    } finally {
      setPending(null);
    }
  };

  const dialog = pending ? (
    <Modal
      open
      onClose={() => setPending(null)}
      onClick={confirm}
      title={`Excluir ${noun.toLowerCase()}`}
      description={`Tem certeza que deseja excluir "${pending.label}"? Esta ação não pode ser desfeita.`}
      closeButton="Cancelar"
      continueButton="Excluir"
    />
  ) : null;

  return { requestDelete: (id: string, label: string) => setPending({ id, label }), dialog };
}
